import React from "react";

/**
 * ComparisonPair — weather_regret evidence component.
 *
 * Two figures side by side: average bookings on false-alarm days
 * vs clear-forecast days. Show counts of each day type as captions.
 * Surface worst_example_date. No dollar figure (spec §7).
 *
 * Spec references: §7 (weather_regret), §6 rule 7 (no dollar figure).
 */

const ComparisonPair = ({ panel }) => {
  const f = panel.facts || {};
  const falseAlarmDays = Number(f.false_alarm_days) || 0;
  const clearDays = Number(f.clear_forecast_days) || 0;
  const avgFalseAlarm = Number(f.avg_bookings_false_alarm_days) || 0;
  const avgClear = Number(f.avg_bookings_clear_days) || 0;
  const worstDate = f.worst_example_date || null;

  return (
    <div>
      {/* Two stats side by side with a divider — mirrors HeroNumber (weather_loss) */}
      <div className="flex items-baseline justify-center gap-6">
        <div className="text-right">
          <span className="text-3xl font-bold text-orange-500 leading-none">
            {avgFalseAlarm}
          </span>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            avg bookings · {falseAlarmDays} false-alarm days
          </p>
        </div>
        <div className="w-px h-12 bg-gray-200 dark:bg-gray-700 self-center" />
        <div className="text-left">
          <span className="text-3xl font-bold text-emerald-600 dark:text-emerald-400 leading-none">
            {avgClear}
          </span>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            avg bookings · {clearDays} clear-forecast days
          </p>
        </div>
      </div>

      {/* FYI-style muted caption */}
      {worstDate && (
        <p className="text-[11px] text-gray-400 dark:text-gray-500 mt-3 text-center italic">
          Worst example: {worstDate}
        </p>
      )}
    </div>
  );
};

export default ComparisonPair;
